import Layout from 'Components/Layout';
import Header from 'Components/Header';
import LogoTalentaInsight from 'Components/Logo';
import AccessDenied from 'Components/AccessDenied';

function PageAccessDenied() {
  return (
    <Layout>
      <Header>
        <LogoTalentaInsight />
      </Header>
      <AccessDenied />
    </Layout>
  );
}

export default PageAccessDenied;
